import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { TranslocoModule } from '@ngneat/transloco';

import { ComponentsModule } from '@core/components/components.module';
import { SharedModule } from '@core/shared.module';

import { ItemEffects } from '@item/state';

import { ItemLookupDialogGridComponent } from './item-lookup-dialog/grid/grid.component';
import { ItemLookupDialogComponent } from './item-lookup-dialog/item-lookup-dialog.component';

@NgModule({
  declarations: [ItemLookupDialogComponent, ItemLookupDialogGridComponent],
  imports: [CommonModule, SharedModule, ComponentsModule, TranslocoModule, EffectsModule.forFeature([ItemEffects])],
  exports: [ItemLookupDialogComponent],
})
export class ItemModule {}
